'use client';

import PageLoadingFallback from '@/components/GlobalDialog/Loading/PageLoadingFallback';
import GoodsListSkeleton from './GoodsListSkeleton';

/** 将骨架和遮罩放在同一客户端渲染边界，避免 fallback 的迟到流片段访问已移除的占位。 */
export default function GoodsListLoadingFallback() {
  return (
    <PageLoadingFallback>
      <GoodsListSkeleton />
    </PageLoadingFallback>
  );
}
